export default "__VITE_ASSET__44879f41__"